/**
 * Textos do painel do dado no documento da mesa (E203.F2, ADR-0146): o clique numa tabela, numa
 * linha ou num texto protegido abre o painel ao lado, com o que está impresso, de onde veio, os
 * campos que se ajustam e, para a prova e o método, por que não mudam e o que dá para fazer.
 */
export const ptBRPainelDoDado = {
  dica: 'Clique para ver de onde vem e ajustar',
  rotulo: 'Painel do dado',
  arrastar: 'Arraste para mover o painel',
  fechar: 'Fechar o painel',
  impresso: 'Impresso no documento',
  verNaFonte: 'Ver na fonte',
  carregando: 'Lendo o dado…',
  erro: 'Não foi possível ler este dado agora.',
  tentarDeNovo: 'Tentar de novo',
  salvar: 'Salvar',
  salvo: 'Salvo. O caso foi conferido de novo e o documento se refaz.',
  falhou: 'Não foi possível salvar. O que você escreveu continua aqui.',
  // E203.F4.C (F-E203.F4-04): a revisão recusada pela versão do documento; o que se digitou fica.
  recusa: {
    assinado: 'Este documento já foi assinado; a correção não foi gravada.',
    desatualizado: 'O documento mudou desde que você abriu este painel. Feche e abra de novo.',
  },
  descartar: {
    titulo: 'Descartar o que não foi salvo?',
    texto: 'O painel tem alteração que ainda não foi salva. Se fechar, ela se perde.',
    ficar: 'Continuar no painel',
    sair: 'Descartar e fechar',
  },
  titulo: {
    declarado: 'Dado declarado',
    lido: 'Dado lido do documento',
    credito: 'Leitura do comprovante de crédito',
    situacao: 'Resultado da conferência',
    conclusao: 'Conclusão',
    facial: 'Análise facial',
    portal: 'Conferência no portal',
    risco: 'Risco do relatório',
    prova: 'Prova registrada',
    catalogo: 'Texto do método',
  },
  cadastro: {
    texto: 'O cadastro do caso, como o exame o imprime. Ao salvar, o caso é conferido de novo.',
    parties: 'Nome do cliente',
    cpf: 'CPF',
    process_number: 'Procedimento nº',
    contrato: 'Proposta ou contrato',
    endereco: 'Endereço',
    semMudanca: 'Nenhum campo mudou.',
  },
  codigo: {
    texto:
      'O código declarado na origem de cada documento. O SHA-256 de custódia, calculado na chegada, não muda; o confronto refaz ao salvar.',
    rotulo: 'Código declarado de {nome}',
    semDocumentos: 'O caso ainda não tem documento da contratação para declarar o código.',
  },
  protocolo: {
    texto:
      'O protocolo de assinatura do caso. Ao salvar, as peças são conferidas de novo e o documento se refaz.',
    concluido:
      'Há peça com a conclusão registrada: para corrigir o protocolo, reabra a conclusão na área Conclusão.',
    instante:
      'O instante da assinatura muda pelo protocolo: corrija a data e o horário da assinatura abaixo.',
  },
  lido: {
    semCampo:
      'Este dado não está na leitura deste caso. Se veio do cadastro, corrija pelo cadastro do caso.',
  },
  revisao: {
    texto:
      'O resultado é o que a conferência calculou. Você o revisa com fundamento; a revisão fica no histórico do caso.',
    semPonto:
      'Nenhum ponto deste tipo aguarda revisão agora. As revisões registradas ficam na área Conclusão.',
    abrirConclusao: 'Abrir a área Conclusão',
  },
  situacao: {
    resultado:
      'O resultado geral, a régua e os eixos são recalculados a partir das linhas de conferência. Corrija o dado de base na seção da conferência, ou revise a linha com fundamento.',
    linha:
      'O resultado desta linha sai do dado de base. Corrija o dado (cadastro, protocolo ou leitura) e a conferência refaz.',
  },
  credito: {
    // E203.F4 (ADR-0146 §7): a correção com fonte.
    texto:
      'O que a leitura do comprovante achou. Corrija com o valor como está impresso, o documento e a página de onde ele saiu; o confronto refaz com o valor corrigido, e o documento imprime só o seu valor.',
    pagina: 'Comprovante, página {pagina}',
    semCredito: 'Este caso não tem crédito lido do comprovante para corrigir.',
    campos: {
      banco: 'Banco',
      agencia: 'Agência',
      conta: 'Conta',
      titular: 'Titular',
      documento: 'CPF ou CNPJ do titular',
      valor: 'Valor (reais, com ponto: 1234.56)',
      data: 'Data',
    },
    fonte: 'Documento de onde saiu o valor',
    paginaDaFonte: 'Página',
    // E207.F7.C01: na linha da conferência, os valores lidos ficam recolhidos.
    corrigirValorLido: 'Corrigir um valor lido',
    manterValoresLidos: 'Manter os valores lidos',
    // E203.F4.C (F-E203.F4-06): o crédito corrigido (o alvo) é escolhido à parte da fonte.
    alvo: 'Crédito que você corrige',
    escolhaOAlvo: 'Escolha o crédito',
    escolhaAntes: 'Escolha acima o crédito que você corrige.',
    opcaoDoAlvo: '{arquivo}, página {pagina} · contrato {contrato} · valor {valor}',
    comprovante: 'Comprovante',
    semLeitura: 'não lido',
  },
  fundamento: {
    rotulo: 'Fundamento',
    dica: 'Por que muda, com a fonte. Fica no histórico do caso, com o valor anterior.',
  },
  // E207.F7.C01 (owner, 01/11): o Salvar fica ligado e diz o que falta.
  falta: {
    resultado: 'Escolha o resultado da linha.',
    resultadoOuValor: 'Escolha o resultado da linha ou corrija um valor lido.',
    valor: 'Altere um valor lido para salvar.',
    pagina: 'Informe a página do documento de onde saiu o valor (1 ou mais).',
    fundamento: 'Escreva o fundamento com pelo menos {n} caracteres.',
    requisito: 'Escolha o resultado do requisito.',
    // E211.F4: no valor livre, ao menos um valor muda.
    valorLivre: 'Altere o valor para salvar.',
    // E222.F1: a modalidade da operação informada pelo perito.
    modalidade: 'Escolha a modalidade da operação.',
    // E211.F2: na linha da custódia, ao menos uma coluna muda.
    custodia: 'Mude a Integridade ou o Vínculo da linha para salvar.',
  },
  // E211.F3 (owner, 01/11): o requisito da matriz e o eixo de geolocalização, com nota numerada.
  requisito: {
    texto:
      'O resultado deste requisito na matriz. Mude-o com fundamento: a matriz imprime o seu resultado com a nota numerada e a contagem dos requisitos acompanha. A conclusão da formalização não muda por aqui: se o requisito revisto muda a conclusão, registre a revisão na aba Pendências.',
    rotulo: 'Resultado do requisito',
    escolha: 'Escolha o resultado',
    resultados: {
      atendido: 'Atendido',
      nao_violada: 'Vedação não violada',
      parcial: 'Parcial',
      pendente: 'Pendente',
      nao_demonstrado: 'Não demonstrado',
      irregular: 'Irregular',
    },
  },
  eixo: {
    texto:
      'O resultado do eixo de geolocalização da página 1, que vem da distância medida. Mude-o com fundamento: o eixo imprime o seu resultado com a nota numerada abaixo da tabela dos eixos.',
  },
  // E211.F4 (owner, 01/11): a rede e as referências da geolocalização, com o valor do perito.
  valor: {
    texto:
      'O valor lido desta linha. Corrija-o com o seu valor, a fonte e o fundamento: a tabela imprime o seu valor com a nota numerada, que traz o fundamento e a fonte. O valor lido fica no histórico do caso.',
    colunas: {
      natureza: 'Natureza do endereço',
      localizacao: 'Localização',
      distancia: 'Distância',
    },
    fonte: 'Fonte do valor',
    dicaDaFonte: 'Opcional. Onde o valor foi conferido; sai na nota, depois do fundamento.',
  },
  // E211.F2 (owner, 01/11): a Integridade e o Vínculo da linha do documento, com nota numerada.
  custodia: {
    texto:
      'O resultado desta linha: a Integridade (o SHA-256 do arquivo frente ao declarado na origem) e o Vínculo (o documento ligado a esta transação). Mude um ou os dois com fundamento: a tabela imprime o seu resultado com a nota numerada, e os eixos de integridade e de vínculo da página 1 são recalculados. O hash declarado, o SHA-256 de custódia e o carimbo do tempo são prova registrada e não mudam.',
    colunas: { integridade: 'Integridade', vinculo: 'Vínculo' },
    escolha: 'Escolha o resultado',
    resultados: {
      integridade: {
        consistente: 'Consistente: confere com o declarado',
        inconclusivo: 'Não verificável',
        divergente: 'Divergente do declarado',
      },
      vinculo: {
        consistente: 'Consistente: ligado a esta transação',
        inconclusivo: 'Inconclusivo: sem confirmação',
        divergente: 'Divergente: não se liga a esta transação',
      },
    },
  },
  linha: {
    texto:
      'O resultado desta linha da conferência de identidade. O perito o muda com fundamento; o eixo de identidade é recalculado das linhas.',
    // E207.F7: a linha do crédito abre pelo resultado; consistente numa divergência é o aceite.
    // E207.F7.C01: os valores lidos ficam recolhidos; um fundamento e um Salvar.
    textoDoCredito:
      'O resultado desta linha do crédito. Consistente numa divergência apurada registra o aceite com o seu fundamento, que sai no exame como nota numerada. Os valores lidos do comprovante ficam como estão; para corrigir um, abra "Corrigir um valor lido".',
    rotulo: 'Resultado da linha',
    escolha: 'Escolha o resultado',
    resultados: {
      consistente: 'Consistente',
      inconclusivo: 'Inconclusivo',
      divergente: 'Divergente',
    },
  },
  grauDoRisco: {
    texto:
      'O grau e o fato deste risco. Mudar o grau reordena os riscos e as prioridades antes da juntada.',
    grau: 'Grau',
    graus: { alto: 'Alto', medio: 'Médio', baixo: 'Baixo' },
    escolha: 'Escolha o grau',
    fato: 'Fato (deixe em branco para manter o impresso)',
    semAncora: 'Este risco ainda não se revisa por aqui: abra o relatório de risco de novo.',
  },
  // E222.F1 (owner, 04/11): a modalidade que o material não identifica, informada com fundamento.
  modalidade: {
    texto:
      'A modalidade da operação, quando o material não a identifica (nem termo de autorização do INSS, nem cédula que nomeie o benefício ou outra folha de pagamento). Ao salvar, as peças são conferidas de novo e o exame se refaz; ele diz que a modalidade foi informada pelo assistente técnico, com o seu fundamento.',
    rotulo: 'Modalidade da operação',
    escolha: 'Escolha a modalidade',
    modalidades: {
      consignado_inss: 'Consignado sobre benefício do INSS',
      consignado_trabalhador: 'Consignado do trabalhador do setor privado (CLT)',
      outra: 'Consignado sobre outra folha (servidor, SIAPE, prefeitura, FGTS)',
    },
    outra:
      'Outra folha de pagamento não tem perfil normativo no catálogo: o exame digital não é emitido para essa operação.',
  },
  instante: {
    texto:
      'O instante da assinatura registrada, sem reenviar o protocolo inteiro. Ao salvar, o caso é conferido de novo.',
    rotulo: 'Data e horário da assinatura',
    fuso: 'Fuso (ex.: -03:00)',
  },
  risco: {
    texto:
      'O risco, o uso, a resposta e a providência se editam no próprio mapa, pelo clique no texto. O grau e o fato vêm da conferência.',
  },
  instituicao:
    'A instituição decide quem vê o caso no portal e muda só pelo cadastro da plataforma.',
  explica: {
    custodia:
      'O SHA-256 de custódia foi calculado na chegada do arquivo e prova que o documento examinado é o recebido. Ele não muda.',
    registro: 'O número e a data do registro identificam o exame e não mudam.',
    qr: 'O código de conferência leva à verificação do documento emitido e não muda.',
    mapa: 'O mapa é desenhado a partir da coordenada e do endereço conferidos. Para mudá-lo, corrija o endereço ou a coordenada de origem.',
    fotografias:
      'As fotografias são os arquivos recebidos, sem alteração. Você pode escolher outra fotografia ou refazer a análise na área Fotografias.',
    fecho:
      'O fecho diz quem responde pelo exame, o local e a data da emissão. Muda com a revisão e a assinatura, não por aqui.',
    emissao: 'A data da emissão é a do próprio documento.',
    metodo:
      'Este texto é o método publicado e não muda caso a caso. Para uma observação deste caso, escreva uma nota do perito na seção.',
  },
  // E203.F3 (ADR-0146 §5): as edições de texto depois do dado novo.
  analiseNova: {
    seguiuUm: '1 edição de texto da análise anterior segue no documento.',
    seguiram: '{n} edições de texto da análise anterior seguem no documento.',
    mudouUm: '1 trecho editado mudou com o dado novo e precisa ser conferido.',
    mudaram: '{n} trechos editados mudaram com o dado novo e precisam ser conferidos.',
    conferir: 'Conferir',
  },
  saidas: {
    nota: 'Escrever uma nota do perito nesta seção',
    limitacao: 'Registrar uma limitação',
    fotografias: 'Abrir as fotografias',
    conclusao: 'Abrir a área Conclusão',
    documentos: 'Adicionar documentos',
  },
} as const;
